import ProfileInfo from "@/pages/profiel/ProfileInfo"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/profiel/persoonlijke_gegevens")({
  component: RouteComponent,
})

function RouteComponent() {
  return <ProfileInfo />
}
